import { createStore as _createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { SSMApplicationReducer, UnauthenticatedReducer } from './app-reducer';
import history from './app-history';

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);
const loggerMiddleware = createLogger();

let finalCreateStore = applyMiddleware(
  middleware,
  thunkMiddleware,
  loggerMiddleware,
);

// if we have redux devtools installed hook into it.
/* eslint-disable */
if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  finalCreateStore = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(finalCreateStore);
}

export const unauthenticatedStore = finalCreateStore(_createStore)(
  UnauthenticatedReducer);

export const authenticatedStore = finalCreateStore(_createStore)(
  SSMApplicationReducer);

